export default "64970c3a3137864a.png"